export default __webpack_public_path__ + "static/media/advantage-1.c1473347.png";